<script>
    import { onMount } from 'svelte'
    import { pubsConfig } from '../../store.js'

    let searchBarValue = ''

    function searchFunction (event) {
        event.preventDefault()
        if ($pubsConfig.searchTerms.every(term => term != searchBarValue) && searchBarValue != '') {
            pubsConfig.update(config => {
                const newConfig = { ...config }
                newConfig.searchTerms.push(searchBarValue)
                return newConfig
            })
        }
        searchBarValue = ''
    }

    function deleteSearch (term) {
        pubsConfig.update(config => {
            const newConfig = { ...config }
            const index = newConfig.searchTerms.indexOf(term)
            if (index > -1) {
                newConfig.searchTerms.splice(index, 1)
            }
            return newConfig
        })
    }

    onMount(() => {
        document.getElementById('searchBarInput').addEventListener('keyup', (event) => {
            if (event.keyCode === 13) {
                event.preventDefault()
                document.getElementById('searchButton').click()
            }
        })
    })
</script>

<div class="searchBarBox">
    <form on:submit={searchFunction}>
        <input
            type="search"
            id="searchBarInput"
            bind:value={searchBarValue}
            placeholder="Search our publications"
            aria-label="Search the publications"
        />
        <button id="searchButton">
            <img src="../assets/search.svg" alt="search icon" />
        </button>
    </form>
    {#each $pubsConfig.searchTerms as searchTerm}
        <p>
            {searchTerm}
            <a
                href={'javascript:void(0)'}
                class="deleteSearch"
                on:click={() => deleteSearch(searchTerm)}
            >
                x
            </a>
        </p>
    {/each}
</div>

<style lang="scss">
    #searchBarInput {
        font-size: 0.7rem;
        height: 2rem;
        width: 11rem;
        margin: 0;
    }
    #searchButton {
        vertical-align: top;
        padding: 0;
        margin: 0;
        &:hover {
            cursor: pointer;
        }
        img {
            width: 1.5rem;
            height: 1.5rem;
            margin: 0.2rem;
            display: block;
        }
    }
</style>
